import { ErrorBoundary } from '@healthinal/react-error-utils';
import { ErrorBoundaryContext } from '@healthinal/react-error-utils/ErrorBoundaryContext';
import { isErrorWithInterpretation } from '@healthinal/react-error-utils/ErrorInterpretation';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactNode, useCallback } from 'react';
import { Reshaped } from 'reshaped/bundle';
import { queryClient } from './api/queryClient';
import { ErrorDialog } from './errors/ErrorDialog';
import { useInterpretError } from './errors/useInterpretError';

interface GlobalProvidersProps {
  children: ReactNode;
}

export function getGlobalProviders(theme: string) {
  return ({ children }: GlobalProvidersProps) => {
    const interpretErrorProp = useInterpretError();

    const interpretError = useCallback(
      (error: unknown) => {
        if (isErrorWithInterpretation(error)) {
          return error.interpretation;
        }
        return interpretErrorProp(error);
      },
      [interpretErrorProp],
    );

    return (
      <Reshaped theme={theme} scoped>
        <ErrorBoundaryContext.Provider value={{ interpretError, errorViewComponent: ErrorDialog }}>
          <ErrorBoundary name="root">
            <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
          </ErrorBoundary>
        </ErrorBoundaryContext.Provider>
      </Reshaped>
    );
  };
}
